import { useEffect, useState } from 'react';
import './workboardHalloween.css';

const WorkboardHalloweenPumpkin = () => {
  const [lit, setLit] = useState(false);

  useEffect(() => {
    if (!lit) {
      return undefined;
    }
    const timer = window.setTimeout(() => setLit(false), 2500);
    return () => window.clearTimeout(timer);
  }, [lit]);

  return (
    <div className="wbh-pumpkin-anchor">
      <div
        className={lit ? 'wbh-pumpkin wbh-lit' : 'wbh-pumpkin'}
        data-testid="workboard-halloween-pumpkin"
        onDoubleClick={event => {
          event.stopPropagation();
          event.preventDefault();
          setLit(true);
        }}
      >
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M15 7c0-3 1-5 3-6l1 1c-1 1-2 3-2 5z" fill="#4f7a28" />
          <ellipse cx="9" cy="19" rx="8" ry="10" fill="#e8710a" />
          <ellipse cx="23" cy="19" rx="8" ry="10" fill="#e8710a" />
          <ellipse cx="16" cy="19" rx="8" ry="11" fill="#f28c28" />
          <path className="wbh-face" d="M9 16l3-4 3 4zM17 16l3-4 3 4zM8 21q8 7 16 0l-3 1-2-1-3 2-3-2-2 1z" />
        </svg>
        <span className="wbh-pumpkin-say">Boo!</span>
      </div>
    </div>
  );
};

export default WorkboardHalloweenPumpkin;
